module.exports = __webpack_public_path__ + "media/images/badge/veggente_secondary-0985ba84bc768955ee95d348b21f445b.png";